/* eslint-disable react-hooks/rules-of-hooks */
// 3rd party libraries
import Prismic from '@prismicio/client'
import { RichText, RichTextBlock } from 'prismic-reactjs'
import SliceZone from 'next-slicezone'
import { useGetStaticProps } from 'next-slicezone/hooks'
// Services&Helper functions
import resolver from '../../sm-resolver.js'
// Styles
import s from '../../styles/pages/Advices.module.scss'
import c from 'classnames'
// Components
import { Button } from '../../components/core/button/Button'
import { Container } from '../../components/core/container/Container'
import { Section } from '../../components/core/section/Section'
import { Text } from '../../components/core/text/Text'
import Meta from '../../components/meta/Meta'

// Fetch content from prismic
export const getStaticProps = useGetStaticProps({
    client: Prismic.client('https://minningar.cdn.prismic.io/api/v2'),
    queryType: 'single',
    type: 'hagnytar_upplysingar',
})

type Props = JSX.IntrinsicAttributes & {
    slices: any
    data: {
        titill: RichTextBlock[]
        description: RichTextBlock[]
        buttonlink: string
        [keys: string]: unknown
    }
}

const Page = (props: Props) => {
    return (
        <>
            <Section>
                <Meta
                    title="Minningar - Hagnýtar upplýsingar"
                    seoTitle="Minningar - Að hverju þarf að huga við andlát?"
                    description="Í kjölfar andláts ástvinar þarf fólk að stíga mörg þungbær skref og taka fjölda erfiðra ákvarðana. Til að styðja við aðstandendur geymir Minningar.is ýmsar hagnýtar upplýsingar, fróðleik og yfirlit yfir þjónustuaðila."
                    image="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/meta%2Fada8aa5a-8e66-41a9-81c6-3b1491a2fd24_iStock-1290101336.jpeg?alt=media&token=dcbc085f-5003-43e6-8d6f-555d9c454ba6"
                    url="https://minningar.is/advice/"
                    type="website"
                />
                <Container className={s.header}>
                    <Text variant="h1" className={s.header__item}>
                        {RichText.asText(props.data.titill)}
                    </Text>
                    <Text variant="p-18" className={s.header__item}>
                        {RichText.asText(props.data.description)}
                    </Text>
                    <div className={c(s.header__buttons, s.header__item)}>
                        {props.data.buttonlink && (
                            <Button variant="ghost" to={props.data.buttonlink}>
                                {props.data.buttontext}
                            </Button>
                        )}
                    </div>
                </Container>
            </Section>
            <SliceZone slices={props.slices} resolver={resolver} />
        </>
    )
}

export default Page
